import type { WithTooltipProps, ButtonProps } from 'uikit';
import { withTooltip, Button } from 'uikit';

import cn from 'classnames';
import type { CSSProperties } from 'react';

import Styles from './withTooltip.module.css';

const BtnWithToolTipHoc = withTooltip({
    mode: 'mouseover',
})(Button);

export const ButtonWithTooltip = ({
    buttonProps,
    tooltipProps,
    fakeDisabled = false,
    basePadding = false,
}: {
    buttonProps: ButtonProps & { className?: string } & { style?: CSSProperties };
    tooltipProps: WithTooltipProps;
    fakeDisabled?: boolean;
    basePadding?: boolean;
}) => {
    const { className: btnClassName, ...otherButtonProps } = buttonProps;

    return (
        <BtnWithToolTipHoc
            className={cn(btnClassName, {
                [Styles.fakeDisabled]: fakeDisabled,
                [Styles.basePadding]: basePadding,
            })}
            {...otherButtonProps}
            tooltipProps={{ className: Styles.tooltip, ...tooltipProps }}
        />
    );
};

ButtonWithTooltip.displayName = 'ButtonWithTooltip';
